import { Injectable, computed, inject, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { ApiKeysService } from '../../../core/services';
import { ApiKey } from '../../../core/models';

/**
 * The API key Playground runs are billed to. Picked once in the run bar
 * (playground.html) and shared by every endpoint page, so switching from
 * /rag to /search keeps it.
 */
@Injectable({ providedIn: 'root' })
export class PlaygroundKeyService {
  private readonly apiKeys = inject(ApiKeysService);

  readonly keys = signal<ApiKey[]>([]);
  /** False until the first list arrives, so "no keys" doesn't flash. */
  readonly loaded = signal(false);
  readonly selectedId = signal<string | null>(null);
  readonly selected = computed(() => this.keys().find(k => k.id === this.selectedId()) ?? null);

  /** The active keys (cached by ApiKeysService). Keeps the pick while it's
   *  still active, else falls back to the first key. */
  load(): Observable<ApiKey[]> {
    return this.apiKeys.getActiveApiKeys().pipe(tap(keys => {
      this.keys.set(keys);
      this.loaded.set(true);
      if (!keys.some(k => k.id === this.selectedId())) this.selectedId.set(keys[0]?.id ?? null);
    }));
  }

  select(key: ApiKey): void {
    this.selectedId.set(key.id);
  }
}
